import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MainRoutes from 'src/shared/routes/mainRoutes';
import SilentRenewPage from 'src/modules/auth/pages/silentRenewPage';
import CallbackPage from 'src/modules/auth/pages/callbackPage ';
import { LicenseInfo } from '@mui/x-license-pro';
import { RoutesEnum } from './shared/enums/routes.enum';

LicenseInfo.setLicenseKey(
  '3588807af2d4682d5f0a7bf865e50917Tz0xMDU0MzYsRT0xNzY4MDg5NTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
);

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path={RoutesEnum.CallbackPage} component={CallbackPage} />
        <Route
          exact
          path={RoutesEnum.SilentRenewPage}
          component={SilentRenewPage}
        />
        <Route path={RoutesEnum.Start} component={MainRoutes} />
      </Switch>
    </Router>
  );
};

export default App;
